import React from 'react';
import Spinner from './components/Spinner.jsx';


const CenterEntry = (props) => {

    let center = props.center,
        controller = props.controller,
        not_all_centers = center.slug !== 'all_centers',
        countryString = center.countryCode !== props.country ? ' (' + center.countryCode + ')' : '',
        distanceString = props.distance ? ', ' + Math.round(center.distance) + ' km' : '',
        label = not_all_centers ? (center.displayName + countryString + distanceString) : "Alle Zentren",
        className = props.active ? 'active' : '',
        hasCurrentValue = not_all_centers ? props.currentValue : false
    ;

    if (! not_all_centers) className += ' result-sep'; // class for all centers

    if (hasCurrentValue) {
        let vId = center.displayName.toLocaleLowerCase().indexOf( props.currentValue.toLocaleLowerCase() );

        if (vId > -1) {
            let labelPart1 = center.displayName.substr(0, vId);
            let labelPart2 = center.displayName.substr(vId, props.currentValue.length);
            let labelPart3 = center.displayName.substr(vId + props.currentValue.length) + countryString + distanceString;

            label = <span>{labelPart1}<span className="location-search--found">{labelPart2}</span>{labelPart3}</span>;
        }
    }

    return <li key={center.slug} className={ className }>
        <a href={center.url} onClick={controller.handleCenterClick.bind(controller, center)}>{ label }</a>
    </li>;

};

const SearchPreview = (props) => {

    if (!props.noDropdown && props.items !== null && props.items !== undefined) {

        let lines = [],
            bestItemsLength = 0,
            directHitItemsLength = props.directHitItems ? props.directHitItems.length : 0
            ;

        if (! props.loading) {

            if (props.directHitItems) {
                lines = props.directHitItems.map(function (center, index) {
                    return <CenterEntry
                        key={'c-' + center.slug}
                        center={center}
                        controller={props.logicClass}
                        country={props.country}
                        distance={false}
                        active={props.selectedIndex === index}
                        currentValue={props.currentValue}
                    />;
                });
            }

            if (props.bestItems && props.bestItems.length) {
                bestItemsLength = props.bestItems.length;

                lines = lines.concat(props.bestItems.map(function(center, index){
                    return <CenterEntry
                        key={'c-' + center.slug}
                        center={center}
                        controller={props.logicClass}
                        country={props.country}
                        distance={false}
                        active={props.selectedIndex === index + directHitItemsLength}
                    />;
                }));
            }

            if (props.items.length > 1 || !props.directHitItems.length ) {

                if (!props.city || props.items.length === 0) {
                    console.log('shown as no result');
                }

                lines.push(
                    <li key="best-sep" className="other-sep">
                        { props.city && props.items.length > 1 ? 'In der Nähe von ' + props.city : 'kein Ergebnis...'}
                    </li>
                );
            }


            lines = lines.concat(props.items.map(function (center, index) {
                return <CenterEntry
                    key={'c-' + center.slug}
                    center={center}
                    controller={props.logicClass}
                    country={props.country}
                    distance={true}
                    active={props.selectedIndex === index + directHitItemsLength + bestItemsLength}
                />;
            }));
        } else {

            lines.push(<li key={'loader'}>
                <Spinner config={
                     {
                          lines: 13 // The number of lines to draw
                        , length: 12 // The length of each line
                        , width: 7 // The line thickness
                        , radius: 19 // The radius of the inner circle
                        , scale: 0.25 // Scales overall size of the spinner
                        , corners: 0 // Corner roundness (0..1)
                        , color: '#cc162b' // #rgb or #rrggbb or array of colors
                        , opacity: 0.25 // Opacity of the lines
                        , rotate: 0 // The rotation offset
                        , direction: 1 // 1: clockwise, -1: counterclockwise
                        , speed: 0.6 // Rounds per second
                        , trail: 60 // Afterglow percentage
                        , zIndex: 2e9 // The z-index (defaults to 2000000000)
                        , className: 'spinner' // The CSS class to assign to the spinner
                        , top: '2px' // Top position relative to parent
                        , left: '17px' // Left position relative to parent
                        , position: 'absolute' // Element positioning
                     }
               }/>
            </li>); // the loader
        }

        return <ul className="dropdown-menu">{lines}</ul>;
    } else {
        return null;
    }
};


export default class LocationFinder extends React.Component {

    componentDidUpdate () {
        if (this.props.focus_search) {
            this.refs.searchInput.focus();
        }
    }

    render () {
        if (this.props.initial) {
            let remove = this.props.locationDefined ? <span onClick={this.props.handleClearLocation} className="glyphicon glyphicon-remove"></span> : <span className="icon icon-loupe"></span>;

            return <a className="search-initial" href={this.props.urlAction} onClick={this.props.handleInitialClick}>{this.props.initialText}{remove}</a>;
        } else {
            return <div className={'location-search-input' + (this.props.loading || this.props.items ? ' open' : '')}>
                <div className="search-wrapper dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                     aria-expanded="false">
                    <label className="auto-complete">{this.props.autoComplete}</label>
                    <input ref="searchInput"
                           className="search-input"
                           title={this.props.autoComplete}
                           onKeyDown={this.props.handleArrowKeyInteraction}
                           onKeyUp={this.props.handleInputInteraction}
                           type="search"
                           placeholder={this.props.placeholder}
                        />
                </div>
                <SearchPreview
                    loading={this.props.loading}
                    noDropdown={this.props.noDropdown}
                    directHitItems={this.props.directHitItems}
                    bestItems={this.props.bestItems}
                    items={this.props.items}
                    selectedIndex={this.props.selectedIndex}
                    city={this.props.autoCompleteCity}
                    country={this.props.country}
                    currentValue={this.props.currentValue}

                    handleCenterClick={this.props.handleCenterClick}

                    logicClass={this.props.logicClass}
                    />
            </div>
        }
    }
};